/**
 * envGate — canonical client-side prod/non-prod gate, VENDORED into @codel/dova-ds.
 *
 * This is a byte-for-byte copy of the behavior of
 *   portal-www/src/v2/utils/envGate.ts
 * relocated INTO the package so the DS has no reach-up dependency on a
 * portal-www util. The two source consumers inside the package
 * (FriendlyError.tsx, MissingMappedData.tsx) — plus the three __tests__
 * that stub it — repoint at this module instead of `../../utils/envGate`.
 *
 * Decision (unchanged from portal-www):
 *
 *   isNonProd() returns true unless the bundled `VITE_ENV_NAME` is explicitly
 *   `production` or `prod`.
 *
 * Why this signal and not `import.meta.env.PROD`: PROD is true for every
 * NON-development Vite build, so a staging build reports PROD=true and we
 * lose the staging-vs-prod distinction. `VITE_ENV_NAME` is an explicit
 * bundle-time environment signal, so consuming apps can migrate hosts on
 * different schedules. Host-substring matching was removed because it
 * incorrectly classifies production when its hostname convention changes.
 *
 * Adding a new environment? Drop a matching `.env.<name>` in each consuming
 * app (portal-www, frontend, prototype-www, …) and set `VITE_ENV_NAME`; only
 * `production` or `prod` is prod.
 *
 * NOTE: relies on `import.meta.env` (vite/vitest provide it). The package's
 * tsconfig template pulls in `vite/client` types so `import.meta.env` is typed
 * in this workspace; consuming apps already supply it at build/test time.
 */

const ENV_NAME = import.meta.env?.VITE_ENV_NAME ?? "development";
const PROD_ENV_NAMES = new Set(["production", "prod"]);

export function isNonProd(): boolean {
    return !PROD_ENV_NAMES.has(ENV_NAME);
}
